module.exports = {"button.close":"Zavrieť"}